import React, {Component} from 'react';
import { Row, Col, List, Avatar, Icon } from 'antd';
import './ApplicationCard.css';
import jsondata from './data_applications.json';


// var mydata = JSON.parse(JSON.stringify(jsondata));
//  console.log(props.data);

class ApplicationCard extends Component {

  renderLoading() {
    return <div>Loading...</div>;
  }

  renderPickCardData(cardPick,pick) {
    // console.log(pick);
    // var pick = 'Medical-Device2';
    var cardData = cardPick.filter((x,i)=> x.id===pick);
    // console.log(cardData[0]);
    if (this.cardData==='undefined') { 
      return this.renderLoading();
    } else {
      return this.renderCard(cardData[0]);
    }
  }

  renderCard(cardData){
    return (
      <div className="ApplicationCard--container" id={cardData.title} name={cardData.title}>
        <div className="ApplicationCard--headline">
          <Icon type="solution" style={{color:'#182675', marginRight:10}}/>  {cardData.headline}
        </div>
        <Row>
          <Col md={10} style={{float:'left'}}>
          <div className="ApplicationCard--image">
            <img className="ApplicationCard--img-main img-responsive img-rounded" alt="app1" src={cardData.img_url} />
            </div>
          </Col>
          <Col md={14} >
            <div className="ApplicationCard--description">
              <div className="ApplicationCard--subheadline">
              {cardData.subheadline}
              </div>
              <div className="ApplicationCard--body-text">
                <p>
                {cardData.description1}
                </p>

                <List
                  itemLayout="horizontal"
                  dataSource={cardData.subarticle}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<Avatar color='red' icon="solution" />}
                        title={<span className="ApplicationCard--list-item-headline">{item.title}</span>}
                        description={item.description}
                      />
                    </List.Item>
                  )}
                />
              </div>
            </div>            
          </Col>
        </Row> 
        {/* <Row>
          <Col md={24}>         
          <p style={{padding:20}}>
            {(cardData.description2!=='') ? cardData.description2 : null}
            </p>
          </Col>
        </Row> */}

      </div>
    )
  }
  
  render(){

    if (!this.props.pick) { 
      return this.renderLoading();
    // } else if (this.renderPickCardData(jsondata,this.props.pick)==='undefined'){
    //   return this.renderLoading();
    } else if (this.props.pick){
      return this.renderPickCardData(jsondata,this.props.pick);
    }

  
  }
}

 export default ApplicationCard;


// WEBPACK FOOTER //
// ./src/common/Cards/ApplicationCard/ApplicationCard.js